"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DefaultStyling = require("./DefaultStyling");
Object.keys(_DefaultStyling).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DefaultStyling[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DefaultStyling[key];
    }
  });
});
var _CopyToClipboardStyling = require("./CopyToClipboardStyling");
Object.keys(_CopyToClipboardStyling).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CopyToClipboardStyling[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CopyToClipboardStyling[key];
    }
  });
});